"use client";

import { ESystemRoles } from "@constants/SystemRoles";
import { User, UserCog, UserPen } from "lucide-react";
import useTranslation from "next-translate/useTranslation";
import type { SystemRoleOption } from "./system-role-selector-v2";

export function useSystemRoleOptions(): SystemRoleOption[] {
  const { t } = useTranslation("common");

  return [
    {
      value: ESystemRoles.ADMIN,
      icon: <UserCog className="h-4 w-4" strokeWidth={1.75} />,
      title: t("Admin"),
      description: t(
        "Admin, acceso completo a todas las configuraciones y funciones"
      ),
    },
    {
      value: ESystemRoles.LEADER,
      icon: <UserPen className="h-4 w-4" strokeWidth={1.75} />,
      title: t("Líder"),
      description: t(
        "Líder, acceso completo para crear y leer recursos, encuestas, evaluaciones y ver recursos"
      ),
    },
    {
      value: ESystemRoles.USER,
      icon: <User className="h-4 w-4" strokeWidth={1.75} />,
      title: t("Usuario"),
      description: t(
        "Usuario, acceso para leer todos los recursos, explorar, responder a evaluaciones, encuestas y ver recursos"
      ),
    },
  ];
}
